module.exports = __webpack_public_path__ + "static/media/FredSaville.a8b6ebf5.png";